// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import RippleButton from '../../../../components/RippleButton';
import type { ReconciliationStore } from '../../../../types/shoppingCenterType';

type Props = {
  store: ReconciliationStore,
  mapOnClick: () => void,

}

export default function MappableStoreButton({ store, mapOnClick }: Props) {
  return (
    <RippleButton
      key={store.id}
      className="mercury-only-store"
      onClick={mapOnClick}
    >
      <span>
        {
          I18n.t('MAPPING_MODE.name', {
            mercuryName: store.mercuryName,
            retailerName: store.retailerName,
          })
        }
      </span>
      {
        store.idMercury
        && (<span>{I18n.t('MAPPING_MODE.idMercury', { idMercury: store.idMercury })}</span>)
      }
      {
        store.gla
        && (<span>{I18n.t('MAPPING_MODE.gla', { gla: store.gla })}</span>)
      }
      {
        store.openingDate
        && (<span>{I18n.t('MAPPING_MODE.openingDate', { openingDate: store.openingDate })}</span>)
      }
    </RippleButton>
  );
}
